import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

type TokenProviderConfig = {
  authority: string;
  clientId: string;
};

let userManager: UserManager | undefined;

/**
 * Standalone UserManager used only to read the current access token at request time (taken from cuc-data-explorer-fe).
 * It shares the AuthProvider's authority, client id and localStorage store, so it reads the same entry
 * (`oidc.user:{authority}:{client_id}`). The API client gets the freshest token without waiting for a React effect,
 * so requests fired on the first render carry it too. No silent renew here: the AuthProvider owns renewal.
 *
 * Configured once by `createOidcConfig` (features/auth) before the first render.
 */
export function configureTokenProvider({ authority, clientId }: TokenProviderConfig): void {
  userManager = new UserManager({
    authority,
    client_id: clientId,
    redirect_uri: window.location.origin + window.location.pathname,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  });
}

export async function getAccessToken(): Promise<string | undefined> {
  const user = await userManager?.getUser();

  return user?.access_token;
}
